import { render, staticRenderFns } from "./AddDownloadDlg.vue?vue&type=template&id=8bf45324&"
import script from "./AddDownloadDlg.vue?vue&type=script&lang=js&"
export * from "./AddDownloadDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddDownloadDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports